import type { ServerEventName, ServerEventPayload } from "../../net/eventSchemas.js";
import { useChatStore } from "./chatStore.js";

export function dispatchChatEvent<K extends ServerEventName>(event: K, payload: ServerEventPayload<K>) {
  const chat = useChatStore.getState();
  switch (event) {
    case "chat:message":
      chat.message(payload as ServerEventPayload<"chat:message">);
      break;
    case "chat:history":
      chat.history(payload as ServerEventPayload<"chat:history">);
      break;
    case "chat:removed":
      chat.remove((payload as ServerEventPayload<"chat:removed">).id);
      break;
    case "chat:restriction":
      chat.restrict(payload as ServerEventPayload<"chat:restriction">);
      break;
    case "chat:rain:received":
      chat.receive(payload as ServerEventPayload<"chat:rain:received">);
      break;
    case "chat:rain":
      chat.notice({ kind: "rain", data: payload as ServerEventPayload<"chat:rain"> });
      break;
    case "chat:announcement":
      chat.notice({ kind: "win", data: payload as ServerEventPayload<"chat:announcement"> });
      break;
  }
}
